import * as Sentry from '@sentry/react'
import { jwtDecode } from 'jwt-decode'

interface JwtPayload {
    CityID: number // ID города
    exp: number // Expiration time (время истечения)
    role: 'driver' | 'pass' // Роль
    UserID: number // ID пользователя
}

interface JwtState {
    isExpired: boolean
    payload: JwtPayload | null
}

export const getJwtState = (accessToken: string): JwtState => {
    try {
        const now = Date.now() / 1000
        const payload = jwtDecode<JwtPayload>(accessToken)
        const isExpired = payload.exp < now + 5

        return { payload, isExpired }
    } catch (error) {
        Sentry.captureException(error, {
            tags: {
                errorType: 'get-jwt-state-invalid-token',
            },
        })

        return { payload: null, isExpired: true }
    }
}
